module.exports = __webpack_public_path__ + "img/system2-mini.c8f8580a.png";